import { createContext, useContext, useState, useEffect } from "react";

const ModeContext = createContext();

export const ModeProvider = ({ children }) => {
  const [mode, setMode] = useState('c2b'); // Default: C2B

  // Load saved mode from localStorage on mount
  useEffect(() => {
    const savedMode = localStorage.getItem("preferredMode");
    if (savedMode && (savedMode === 'b2b' || savedMode === 'c2b')) {
      setMode(savedMode);
    }
  }, []);

  // Save mode to localStorage when it changes
  useEffect(() => {
    localStorage.setItem("preferredMode", mode);
  }, [mode]);

  return (
    <ModeContext.Provider value={{ mode, setMode }}>
      {children}
    </ModeContext.Provider>
  );
};

export const useMode = () => {
  const context = useContext(ModeContext);
  if (!context) {
    throw new Error("useMode must be used within a ModeProvider");
  }
  return context;
};
